// extracted by mini-css-extract-plugin
export default {"input":"iB","container":"jB"};
    if(module.hot) {
      // 1713211524556
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  